export default "__VITE_ASSET__bZqAhPnI__"